import React from 'react';
import PropTypes from 'prop-types';
import { Link as LinkModel } from 'models';
import LinkWrapper from './LinkWrapper';

const ContactLink = (props) => {
  const {
    data: {
      name,
      url,
    },
  } = props;
  return (
    <LinkWrapper
      href={url}
      dangerouslySetInnerHTML={{
        __html: name,
      }}
      rel="nofollow"
    />
  );
};
ContactLink.propTypes = {
  data: PropTypes.instanceOf(LinkModel).isRequired,
};

export default ContactLink;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ContactLink/index.jsx